import { TemplateRef } from "@angular/core";
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { FormService } from 'src/app/services/form.service';
import { UserService } from 'src/app/services/user.service';
import { MatDialog } from '@angular/material';
var Caracteristica_proyectoComponent = /** @class */ (function () {
    function Caracteristica_proyectoComponent(fb, _userService, dialog) {
        this.fb = fb;
        this._userService = _userService;
        this.dialog = dialog;
        this.rows = [];
        this.matcher = new FormService();
        this.form = new FormGroup({
            destino: new FormControl(''),
            supertotal: new FormControl(''),
            npisos: new FormControl(''),
            modradio: new FormControl(''),
            usoradio: new FormControl('')
        });
        if (!JSON.parse(localStorage.getItem("caracteristica_proyecto"))) {
            localStorage.setItem("caracteristica_proyecto", JSON.stringify(this.rows));
        }
        else {
            this.rows = JSON.parse(localStorage.getItem("caracteristica_proyecto"));
        }
        this.caracteristica_proyecto = { destino: '', supertotal: '', npisos: '', modradio: '', usoradio: '' };
        this.temp_cproy = { destino: '', supertotal: '', npisos: '', modradio: '', usoradio: '' };
        this.n_form = localStorage.getItem('form');
        console.log("Formulario seleccionado", this.n_form);
    }
    Caracteristica_proyectoComponent.prototype.add_caracteristica_proyecto = function () {
        this.actualRow = localStorage.getItem("caracteristica_proyecto");
        this.rows = JSON.parse(this.actualRow);
        if (!this.form.value.destino && !this.form.value.supertotal && !this.form.value.npisos && !this.form.value.modradio && !this.form.value.usoradio) {
            console.log("no ingresó ningun campo");
            this.dialog.open(this.openModalNODATA);
        }
        else {
            this.rows = this.rows.concat({
                destino: this.form.value.destino,
                supertotal: this.form.value.supertotal,
                npisos: this.form.value.npisos,
                modradio: this.form.value.modradio,
                usoradio: this.form.value.usoradio
            });
            localStorage.setItem("caracteristica_proyecto", JSON.stringify(this.rows));
            this.form.reset();
        }
    };
    Caracteristica_proyectoComponent.prototype.delete_caracteristica_proyecto = function (id) {
        for (var x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("caracteristica_proyecto", JSON.stringify(this.rows));
            }
        }
        this.actualRow = localStorage.getItem("caracteristica_proyecto");
        this.rows = JSON.parse(this.actualRow);
    };
    Caracteristica_proyectoComponent.prototype.get_caracteristica_proyecto = function (id) {
        console.log(id);
        for (var x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.temp_cproy.numcaract = id;
                this.temp_cproy.destino = this.rows[x].destino;
                this.temp_cproy.supertotal = this.rows[x].supertotal;
                this.temp_cproy.npisos = this.rows[x].npisos;
                this.temp_cproy.modradio = this.rows[x].modradio;
                this.temp_cproy.usoradio = this.rows[x].usoradio;
                //console.log(this.temp_cproy);
                this.dialog.open(this.openModal);
            }
        }
    };
    Caracteristica_proyectoComponent.prototype.cleanData = function () {
        this.temp_cproy = { destino: '', supertotal: '', modradio: '', usoradio: '' };
    };
    Caracteristica_proyectoComponent.prototype.save_caracteristica_proyecto = function () {
        var id = this.temp_cproy.numcaract;
        console.log(this.temp_cproy);
        for (var x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("caracteristica_proyecto", JSON.stringify(this.rows));
                $("#cproy_modal").modal("hide");
                this.actualRow = localStorage.getItem("caracteristica_proyecto");
                this.rows = JSON.parse(this.actualRow);
                this.rows = this.rows.concat({
                    destino: this.temp_cproy.destino,
                    supertotal: this.temp_cproy.supertotal,
                    npisos: this.temp_cproy.npisos,
                    modradio: this.temp_cproy.modradio,
                    usoradio: this.temp_cproy.usoradio,
                });
                localStorage.setItem("caracteristica_proyecto", JSON.stringify(this.rows));
                this.temp_cproy = { destino: '', supertotal: '', npisos: '', modradio: '', usoradio: '' };
                this.dialog.closeAll();
            }
        }
    };
    return Caracteristica_proyectoComponent;
}());
export { Caracteristica_proyectoComponent };
